export const GuidePaymentType = {
	INVOICE: { id: 1, name: "Nota Fiscal" },
  RPA: { id: 2, name: "RPA" },
};



// WEBPACK FOOTER //
// ./src/enums/GuidePaymentType.js